export const convertToPounds = (value?: number | string | null) => {
    return value == null ? '£0.00' : `£${Number(value).toFixed(2)}`
}
